import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CommonButton } from "../ui/CommonButton";
import { CreateTicketModal } from "../custom/CreateTicketModal";
import { getSupportTickets } from "../../Redux/Action/supportTicketAction";
import { useAppTheme } from "../../Hooks/useAppTheme";

export const SupportTicket = ({ buttontext, buttonSize }) => {
    const dispatch = useDispatch();
    const { tickets, loading } = useSelector((state) => state.SupportTicket);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const theme = useAppTheme();

    useEffect(() => {
        // Fetch tickets when component mounts
        dispatch(getSupportTickets());
    }, [dispatch]);

    const handleCreateTicket = () => {
        setIsModalOpen(true);
    };

    const handleTicketCreated = () => {
        // Refresh tickets after creating a new one
        dispatch(getSupportTickets());
    };

    return (
        <>
            <div className="rounded-xl shadow p-6" style={{ backgroundColor: theme.bgCard }}>
                <div className="flex items-center justify-between mb-4">
                    <h2 className="text-sm font-bold" style={{ color: theme.textPrimary }}>Ticket List</h2>
                    <CommonButton 
                        size={buttonSize} 
                        text={buttontext} 
                        onClick={handleCreateTicket}
                    />
                </div>
                
                {loading ? (
                    <div className="flex justify-center items-center h-32">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2" style={{ borderColor: theme.brandPrimary }}></div>
                    </div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full text-xs text-left">
                            <thead>
                                <tr className="border-b" style={{ color: theme.textSecondary, borderColor: theme.borderPrimary }}>
                                    <th className="py-2 pr-4">#</th>
                                    <th className="py-2 pr-4">TICKET ID</th>
                                    <th className="py-2 pr-4">SUBJECT</th>
                                    <th className="py-2 pr-4">TYPE</th>
                                    <th className="py-2 pr-4">PRIORITY</th>
                                    <th className="py-2 pr-4">DATE</th>
                                    <th className="py-2">STATUS</th>
                                    <th className="py-2">ACTION</th>
                                </tr>
                            </thead>
                            <tbody style={{ color: theme.textPrimary }}>
                                {tickets && tickets.length > 0 ? (
                                    tickets.map((tx, idx) => (
                                        <tr key={tx._id || tx.ticketId} className="border-b last:border-0" style={{ borderColor: theme.borderPrimary }}>
                                            <td className="py-2 pr-4">{idx + 1}</td>
                                            <td className="pr-4 font-medium" style={{ color: theme.brandPrimary }}>{tx.ticketId || `TCKT-${String(idx + 1).padStart(3, '0')}`}</td>
                                            <td className="pr-4">{tx.subject}</td>
                                            <td className="pr-4">{tx.type}</td>
                                            <td className="pr-4">{tx.priority}</td>
                                            <td className="pr-4">{tx.date ? new Date(tx.date).toLocaleDateString() : new Date().toLocaleDateString()}</td>
                                            <td className="pr-4">
                                                <span
                                                    className="px-2 py-0.5 rounded-full text-[10px] font-medium"
                                                    style={{
                                                        backgroundColor: tx.status === "Open" ? `${theme.warning}20` :
                                                            tx.status === "In Progress" ? `${theme.brandPrimary}20` :
                                                                tx.status === "Closed" ? `${theme.textTertiary}20` :
                                                                    tx.status === "Resolved" ? `${theme.success}20` :
                                                                        tx.status === "Pending" ? `${theme.warning}20` :
                                                                            `${theme.warning}20`,
                                                        color: tx.status === "Open" ? theme.warning :
                                                            tx.status === "In Progress" ? theme.brandPrimary :
                                                                tx.status === "Closed" ? theme.textTertiary :
                                                                    tx.status === "Resolved" ? theme.success :
                                                                        tx.status === "Pending" ? theme.warning :
                                                                            theme.warning
                                                    }}
                                                >
                                                    {tx.status || "Open"}
                                                </span>
                                            </td>
                                            <td>
                                                <button className="hover:underline text-sm" style={{ color: theme.brandPrimary }}>View</button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" className="text-center py-4" style={{ color: theme.textTertiary }}>
                                            No support ticket records found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            
            <CreateTicketModal 
                isOpen={isModalOpen} 
                onClose={() => setIsModalOpen(false)}
                onSubmitSuccess={handleTicketCreated}
            />
        </>
    );
};